import { render } from "./AppInstallation.vue?vue&type=template&id=3358e4a0&lang=true"
import script from "./AppInstallation.vue?vue&type=script&lang=js"
export * from "./AppInstallation.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__